import { BookAppointment } from "@/features/patient/appointments/components/book/book-appointment";

function PatientFindAppointments() {
    return (
        <div className="px-4 py-8">
            <div className="container mx-auto">
                <div className="mb-4 flex">
                    <h1 className="mb-4 text-2xl font-semibold">
                        Complete your booking
                    </h1>
                </div>
                <BookAppointment />
            </div>
        </div>
    );
}

export default PatientFindAppointments;
